import { render, staticRenderFns } from "./shipper.vue?vue&type=template&id=f83c67c2&"
import script from "./shipper.vue?vue&type=script&lang=js&"
export * from "./shipper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f83c67c2')) {
      api.createRecord('f83c67c2', component.options)
    } else {
      api.reload('f83c67c2', component.options)
    }
    module.hot.accept("./shipper.vue?vue&type=template&id=f83c67c2&", function () {
      api.rerender('f83c67c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/ae/basic/shipper.vue"
export default component.exports